// extracted by mini-css-extract-plugin
export default {"row":"EvaluationItem_row__0M1cM","content":"EvaluationItem_content__+o7e0","title":"EvaluationItem_title__bkZAI"};